module.exports = __webpack_public_path__ + "img/qilin-f-stage7-sulking.f6d6c0aa.png";